<template>
  <div>
    <HeaderSection icon="fas fa-question" title="Ayuda">
      <template slot="buttons">
        <el-button
            size="medium"
            type="danger"
            icon="el-icon-arrow-left"
            @click="$router.push('/')">
          Regresar
        </el-button>
      </template>
    </HeaderSection>
    <br>

    <el-collapse v-model="activeName" accordion>
      <el-collapse-item title="Formatos alta y baja" name="1">
        <el-row>
          <el-col :span="12">
            <el-button type="text" icon="fas fa-excel" @click="downloadExcel(1)">
              Formato alta
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-button type="text" icon="fas fa-excel" @click="downloadExcel(2)">
              Formato baja
            </el-button>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item title="Apoyo Multimedia - Proceso MSE" name="2">
        <el-row>
          <el-col :span="24">
            <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
                class="fas fa-volume-up"></i></label>
            <video-player class="video-player-box"
                          controlBar={false}
                          ref="videoPlayer1"
                          @ended="onPlayerEnded($event)"
                          :controlBar="false"
                          :options="playerOptions"
                          :playsinline="true"
                          customEventName="customstatechangedeventname">
            </video-player>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item title="Apoyo Multimedia-Dictamen Técnico" name="3">
        <el-row>
          <el-col :span="24">
            <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
                class="fas fa-volume-up"></i></label>
            <video-player class="video-player-box"
                          controlBar={false}
                          ref="videoPlayer2"
                          @ended="onPlayerEnded($event, 2)"
                          :controlBar="false"
                          :options="playerOptionsInformatic"
                          :playsinline="true"
                          customEventName="customstatechangedeventname">
            </video-player>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item title="Apoyo Multimedia-Anexo Técnico" name="4">
        <el-row>
          <el-col :span="24">
            <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
                class="fas fa-volume-up"></i></label>
            <label class="el-form--label-top">Apoyo Multimedia-Anexo Técnico</label>
            <video-player class="video-player-box"
                          controlBar={false}
                          ref="videoPlayer3"
                          @ended="onPlayerEnded($event, 3)"
                          :controlBar="false"
                          :options="playerOptionsAnex"
                          :playsinline="true"
                          customEventName="customstatechangedeventname">
            </video-player>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item title="Apoyo Multimedia-Investigación de Mercado" name="5">
        <el-row>
          <el-col :span="24">
            <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
                class="fas fa-volume-up"></i></label>
            <label class="el-form--label-top">Apoyo Multimedia-Investigación de Mercado</label>
            <video-player class="video-player-box"
                          controlBar={false}
                          ref="videoPlayer"
                          @ended="onPlayerEnded($event, 3)"
                          :controlBar="false"
                          :options="playerOptionsInvestigation"
                          :playsinline="true"
                          customEventName="customstatechangedeventname">
            </video-player>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item title="Apoyo Multimedia-Justificación 2021" name="6">
        <el-row>
          <el-col :span="24">
            <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
                class="fas fa-volume-up"></i></label>
            <label class="el-form--label-top">Apoyo Multimedia-Justificación 2021</label>
            <video-player class="video-player-box"
                          controlBar={false}
                          ref="videoPlayer4"
                          @ended="onPlayerEnded($event, 3)"
                          :controlBar="false"
                          :options="playerOptionsJustification"
                          :playsinline="true"
                          customEventName="customstatechangedeventname">
            </video-player>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>


  </div>
</template>

<script>
import HeaderSection from "./HeaderSection";

export default {
  components: {
    HeaderSection
  },
  data() {
    return {
      activeName: '',
      playerOptionsInformatic: {
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/Dictamen técnico 27-08-21.MP4"
        }],
        poster: "/img/logo_sre.png",
      },

      playerOptionsAnex: {
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/Anexo Técnico 27-08-21.MP4"
        }],
        poster: "/img/logo_sre.png",
      },
      playerOptionsInvestigation: {
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/MSE- INVESTIGACIÓN V.mp4"
        }],
        poster: "/img/logo_sre.png",
      },
      playerOptionsJustification: {
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/MSE-JUSTIFICACIÓN.mp4"
        }],
        poster: "/img/logo_sre.png",
      },
      playerOptions: {
        // videojs options
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/MSE proceso 27-08-21.MP4"
        }],
        poster: "/img/logo_sre.png",
      }
    }
  },

  mounted() {
    this.$refs?.videoPlayer1?.player?.controlBar?.progressControl?.disable();
    this.$refs?.videoPlayer2?.player?.controlBar?.progressControl?.disable();
    this.$refs?.videoPlayer3?.player?.controlBar?.progressControl?.disable();
    this.$refs?.videoPlayer4?.player?.controlBar?.progressControl?.disable();

  },

  methods: {
    onPlayerEnded(player, type) {
      if (player) {
        let _data = {
          user: this.infoUser.id,
          video: type
        }
        axios.post('/api/user-video', _data).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message);
            if (type == 2) {
              this.showInformatic = true;
              this.showModalInformatic = false;
            }
            if (type == 3) {
              this.showAnex = true;
              this.showModalAnex = false;
            }
          } else {
            this.$message.error(response.data.message)
          }
        }).catch(e => {
          console.log("error ", e)
        })

      }
    },

    downloadExcel(type) {
      if (type == 1) {
        document.location.href = '/storage/Formato alta en el Módulo de Servicios en el Exterior.xls';
      }
      if (type == 2) {
        document.location.href = '/storage/Formato baja en el Módulo de Servicios en el Exterior.xls';
      }
    }
  }


}
</script>

<style scoped>

</style>